import axios from "axios";

export default {
  namespaced: true,
  state: {
    batchdeposits: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    batchdepositsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    FINDING_BATCH_DEPOSITS(state, payload) {
      state.isReceiving = true;
      state.query = Object.assign({}, payload);
    },
    RECEIVED_BATCH_DEPOSITS(state, payload) {
      state.batchdeposits = payload;
      state.isReceiving = false;
    },
    RECEIVING_BATCH_DEPOSITS(state) {
      state.isReceiving = true;
    },
    RECEIVED_BATCH_DEPOSIT(state, payload) {
      state = Object.assign(state, {
        batchdeposits: [...state.batchdeposits, payload],
        isReceiving: false,
      })
    },
    RECEIVING_BATCH_DEPOSIT(state) {
      state.isReceiving = true;
    },
    UPDATED_BATCH_DEPOSIT(state, payload) {
      let index = state.batchdeposits.findIndex(batchdeposit => batchdeposit._id === payload._id);
      state = Object.assign(state, {
        batchdeposits: state.batchdeposits.map((batchdeposit, i) => {
          if (i === index) {
            return Object.assign({}, batchdeposit, payload);
          }
          return batchdeposit;
        }),
        isUpdating: false,
        batchdepositsMessage: 'BatchDeposits has been updating!',
      })
    },
    UPDATING_BATCH_DEPOSIT(state) {
      state.isUpdating = true;
    },
    DELETED_BATCH_DEPOSIT(state, payload) {
      let indexToDelete = state.batchdeposits.findIndex(batchdeposit => batchdeposit._id === payload._id);
      let batchdeposits = [...state.batchdeposits];
      batchdeposits.splice(indexToDelete, 1);
      state = Object.assign(state, {
        batchdeposits: [...batchdeposits],
        isDeleting: false,
        idToDelete: null,
        batchdepositsMessage: 'BatchDeposit has been Deleted!',
      });
    },
    DELETING_BATCH_DEPOSIT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteBatchDepositRequest({dispatch}, payload) {
      dispatch("deletingBatchDeposit", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/batchdeposit/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteBatchDeposit", response.data);
      })
    },
    async getBatchDepositsRequest({dispatch}) {
      dispatch("receivingBatchDeposits");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/batchdeposits';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url,headers: headers})
      .then(res => {
        dispatch("receiveBatchDeposits", res.data);
      })
    },
    async findBatchDepositsRequest({dispatch}, payload) {
      try{
        dispatch("findingBatchDeposits", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/batchdeposits';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertBatchDepositRequest({dispatch}, payload) {
      dispatch("receivingBatchDeposits");
      let data = payload;
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/batchdeposit'; 
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      await axios({method: "post", url: url, headers: header, data: data})
      .then(response=> {
        dispatch("receiveBatchDeposit", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async updateBatchDepositRequest({dispatch}, payload) {
      dispatch("updatingBatchDeposit");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/batchdeposit/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method:"put", url:url, headers:header, data:payload})
      .then((response)=> {
        dispatch("updateBatchDeposit", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateBatchDepositTransaction({dispatch}, payload) {
      try{
        dispatch("updatingBatchDeposit");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/bdtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateBatchDeposit", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateBatchDepositPendingRequest({dispatch}, payload) {
      dispatch("updatingBatchDeposit");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/batchdeposit/pending/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateBatchDeposit", response.data);
      return response.data;
    },
    async updateBatchDepositConfirmRequest({dispatch}, payload) {
      dispatch("updatingBatchDeposit");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/batchdeposit/confirm/' + id;
      console.log(token, url)
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateBatchDeposit", response.data);
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    findingBatchDeposits({commit}, payload) {
      commit("FINDING_BATCH_DEPOSITS", payload)
    },
    receiveBatchDeposits({commit}, payload) {
      commit("RECEIVED_BATCH_DEPOSITS", payload)
    },
    receivingBatchDeposits({commit}) {
      commit("RECEIVING_BATCH_DEPOSITS")
    },
    receiveBatchDeposit({commit}, payload) {
      commit("RECEIVED_BATCH_DEPOSIT", payload)
    },
    receivingBatchDeposit({commit}) {
      commit("RECEIVING_BATCH_DEPOSIT")
    },
    updateBatchDeposit({commit}, payload) {
      commit("UPDATED_BATCH_DEPOSIT", payload)
    },
    updatingBatchDeposit({commit}) {
      commit("UPDATING_BATCH_DEPOSIT")
    },
    deleteBatchDeposit({commit}, payload) {
      commit("DELETED_BATCH_DEPOSIT", payload)
    },
    deletingBatchDeposit({commit}, payload) {
      commit("DELETING_BATCH_DEPOSIT", payload)
    }
  },
};
